// The surfaces the pages repeat: a bordered white card, and the light
// header of a list (a group of tasks, its skeleton).
export const CARD_CLASS = 'rounded-lg border border-gray-100 bg-white';
export const LIST_HEADER_CLASS = 'bg-[#fcfcfc] px-4 py-3';
// The header of a group in such a list: small grey capitals and its count.
export const LIST_GROUP_HEADER_CLASS = `${LIST_HEADER_CLASS} text-xs font-medium uppercase leading-4 tracking-[0.2px] text-gray-500`;
